import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6">
        {/* Main Footer Content */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">香香漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              香香漫画是在线看韩漫的官网，提供韩国漫画免费阅读和下拉式韩漫大全，内容优质，浏览流畅，为您营造愉快的阅读时光。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-xs"></i>
                <span>contact@xiangxiangcomic.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-customer-service-line text-xs"></i>
                <span>在线客服：周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 香香漫画 XiangXiangComic.com - 韩国漫画免费阅读平台 | All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors duration-200" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}